import React from "react";


import Loading from "../components/Loading";

export default function LoadingExample() {



  return (
    <>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100vw",
            height: "100vh",
            backgroundColor: "#f0f0f0", // Optional: Set a background color
          }}
        >
          <Loading message="Showing off my cool animated icon..." />
        </div>
    </>
  );
}
